/**
 * **What a press on a legal target does while an attack is armed** (`projects/target-mini-forecasts.md`
 * 2.1, `decisions/0186` Consequences). A mouse hovers before it clicks, so the full forecast card is
 * already open when the click lands, and the click commits the attack. A finger has no hover: the
 * first tap on a target expands its card instead, and a second tap on the SAME target commits. A tap
 * on a different target moves the card there. A target with no forecast (Scan, Lock On, Bolster)
 * has no card to expand, so a tap on it commits at once, as a click does.
 *
 * `pointerType` is the `PointerEvent.pointerType` of the press (`"mouse"`, `"pen"`, `"touch"`), or
 * `null` when none was seen; only `"touch"` takes the two-tap path. A pen hovers.
 */
export type TargetTapStep = "commit" | "expand";

export function targetTapStep(args: { pointerType: string | null; targetId: string; expandedId: string | null; hasForecast: boolean }): TargetTapStep {
  const { pointerType, targetId, expandedId, hasForecast } = args;
  if (pointerType !== "touch" || !hasForecast) return "commit";
  return expandedId === targetId ? "commit" : "expand";
}
